// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubRevokePatientConsentResponse {
    static getAttributeTypeMap() {
        return MangoHubRevokePatientConsentResponse.attributeTypeMap;
    }
}
MangoHubRevokePatientConsentResponse.discriminator = undefined;
MangoHubRevokePatientConsentResponse.attributeTypeMap = [
    {
        "name": "hasPatientConsent",
        "baseName": "hasPatientConsent",
        "type": "boolean"
    }
];
//# sourceMappingURL=mangoHubRevokePatientConsentResponse.js.map